import { Component, ViewChild, Injectable, ChangeDetectionStrategy, ChangeDetectorRef, NgModule, EventEmitter, Renderer2, Input, Output, ElementRef, HostListener } from '@angular/core';
import { RouterOutlet, RouterModule } from '@angular/router';
import { BreadcrumbService, BrowserPendingChangesService, NavigationService, BreadCrumbModule } from '@wke/ucc-angular-alt-navigation';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { debounceTime, takeWhile, tap } from 'rxjs/operators';
import { Type, LocaleService, PopupModule, TooltipModule } from '@wke/ucc-angular-alt-common';
import { NotificationsService, NotificationsModule } from '@wke/ucc-angular-alt-notifications';
import { IconModule } from '@wke/ucc-icons';
import { ImageModule, BadgeModule } from '@wke/ucc-angular-alt-drawing';
import { FormsModule } from '@angular/forms';

/**
 * Este componente se utiliza para la declaración de la shell principal de la aplicación, en la cual podemos definir dos
 * zonas principales: El Header, que es la parte superior, y el SideBar, que es la parte lateral izquierda.
 * Además de estas dos zonas la shell incluye el [Breadcrumb]{@link BreadCrumbComponent} de la aplicación,
 * el KittLoader [KittLoaderComponent]{@link KittLoaderComponent} para identificar llamadas a servidor,
 * y el router outlet, que es el contenido principal de las páginas
 *
 * @example
 * <ngwk-shell>
 *  <shell-header>
 *    Shell Header
 *  </shell-header>
 *  <shell-side-bar>
 *    Shell Side Bar
 *  </shell-side-bar>
 * </ngwk-shell>
 *
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@wke/ucc-angular-alt-navigation';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@wke/ucc-angular-alt-notifications';
import * as ɵngcc4 from '@wke/ucc-angular-alt-common';
import * as ɵngcc5 from '@wke/ucc-icons';
import * as ɵngcc6 from '@angular/common';
import * as ɵngcc7 from '@wke/ucc-angular-alt-drawing';

const _c0 = ["routerOutlet"];
const _c1 = [[["shell-header"]], [["shell-side-bar"]]];
const _c2 = ["shell-header", "shell-side-bar"];
const _c3 = ["anchor"];
function HeaderComponent_div_8_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "button", 14);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_div_8_div_3_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.onChangeCompany(); });
    ɵngcc0.ɵɵelement(2, "ucc-icon", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngwkTooltip", ctx_r4.changeCompanyTooltip)("ngwkTooltipPosition", ctx_r4.changeCompanyTooltipPosition);
} }
function HeaderComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelement(2, "ngwk-company-card", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, HeaderComponent_div_8_div_3_Template, 3, 2, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("company", ctx_r0.company);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canChangeCompany);
} }
function HeaderComponent_button_11_ngwk_badge_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ngwk-badge", 19);
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    const position_r8 = ctx_r10.index;
    const headerBarItem_r7 = ctx_r10.$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r9.getHeaderBarItemBadgeId(position_r8))("show", true)("left", ctx_r9.getLeftDistanceForBadge(position_r8))("color", ctx_r9.getHeaderBarItemBadgeColor(headerBarItem_r7));
} }
function HeaderComponent_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 16);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_button_11_Template_button_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r12); const headerBarItem_r7 = restoredCtx.$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onHeaderBarItemClick(headerBarItem_r7); });
    ɵngcc0.ɵɵelement(1, "ucc-icon", 17);
    ɵngcc0.ɵɵtemplate(2, HeaderComponent_button_11_ngwk_badge_2_Template, 1, 4, "ngwk-badge", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const headerBarItem_r7 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", headerBarItem_r7.id)("ngwkTooltip", headerBarItem_r7.tooltipText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("key", headerBarItem_r7.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.headerHeaderBarItemHasBadge(headerBarItem_r7));
} }
function HeaderComponent_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20, 21);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_button_12_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onShowNotificationsChange(); });
    ɵngcc0.ɵɵelement(2, "ucc-icon", 22);
    ɵngcc0.ɵɵelementStart(3, "ngwk-badge", 23);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngwkTooltip", ctx_r2.notificationsTooltipText);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("show", ctx_r2.showTotalNewNotifications)("left", ctx_r2.notificationsBadgeLeftDistance);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.totalNewNotifications, " ");
} }
function HeaderComponent_ngwk_notifications_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ngwk-notifications", 24);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("showNotifications", ctx_r3.showNotifications)("anchor", ctx_r3.anchor);
} }
const _c4 = ["*"];
function CompanyCardComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 5);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngwkImage", ctx_r0.company == null ? null : ctx_r0.company.logoUrl);
} }
const _c5 = ["container"];
const _c6 = ["icon"];
function UserCardComponent_ngwk_popup_11_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 13);
    ɵngcc0.ɵɵlistener("click", function UserCardComponent_ngwk_popup_11_button_2_Template_button_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const item_r4 = restoredCtx.$implicit; return item_r4.onClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    ɵngcc0.ɵɵpropertyInterpolate("id", item_r4.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r4.label);
} }
function UserCardComponent_ngwk_popup_11_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngwk-popup", 10);
    ɵngcc0.ɵɵlistener("close", function UserCardComponent_ngwk_popup_11_Template_ngwk_popup_close_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onMenuClose(); });
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵtemplate(2, UserCardComponent_ngwk_popup_11_button_2_Template, 2, 2, "button", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵproperty("anchor", _r0)("anchorAlign", ctx_r2.anchorAlign)("popupAlign", ctx_r2.popupAlign);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.menuItems);
} }
class ShellComponent {
    /** @ignore */
    constructor(_breadcrumbService, _browserPendingChangesService) {
        this._breadcrumbService = _breadcrumbService;
        this._browserPendingChangesService = _browserPendingChangesService;
        this._subscriptionRouterOutletActivatedRoute = null;
        /** @ignore */
        this.routerOutlet = null;
    }
    /** @ignore */
    onComponentLoaded(component) {
        if (this._subscriptionRouterOutletActivatedRoute && !this._subscriptionRouterOutletActivatedRoute.closed) {
            this._subscriptionRouterOutletActivatedRoute.unsubscribe();
        }
        this._subscriptionRouterOutletActivatedRoute = this.routerOutlet.activatedRoute.params
            .subscribe(() => this._breadcrumbService.addItem(component));
        this._browserPendingChangesService.registerComponent(component);
    }
}
ShellComponent.ɵfac = function ShellComponent_Factory(t) { return new (t || ShellComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BreadcrumbService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BrowserPendingChangesService)); };
ShellComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ShellComponent, selectors: [["ngwk-shell"]], viewQuery: function ShellComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7, RouterOutlet);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.routerOutlet = _t.first);
    } }, ngContentSelectors: _c2, decls: 12, vars: 0, consts: [["id", "modal-full-lateral-container", 1, "shellGrid"], [1, "shellHeaderGrid"], [1, "shellSideBarGrid"], [1, "shellBreadcrumbGrid"], [1, "shellKittLoaderGrid"], ["id", "modal-lateral-container", 1, "shellContainerGrid"], [3, "activate"], ["routerOutlet", ""]], template: function ShellComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c1);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelement(6, "ngwk-breadcrumb");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵelement(8, "ngwk-kitt-loader");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 5);
        ɵngcc0.ɵɵelementStart(10, "router-outlet", 6, 7);
        ɵngcc0.ɵɵlistener("activate", function ShellComponent_Template_router_outlet_activate_10_listener($event) { return ctx.onComponentLoaded($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [ɵngcc1.BreadCrumbComponent, KittLoaderComponent, ɵngcc2.RouterOutlet]; }, styles: ["[_nghost-%COMP%]     .shellGrid{display:grid;height:100%;width:100%;grid-template-columns:auto 1fr;grid-template-rows:auto auto auto 1fr}[_nghost-%COMP%]     .shellHeaderGrid{grid-row:1;-ms-grid-column:1;-ms-grid-column-span:2;grid-column-start:1;grid-column-end:span 2}[_nghost-%COMP%]     .shellSideBarGrid{width:60px;-ms-grid-row:2;-ms-grid-column:1;-ms-grid-row-span:3;grid-column:1;grid-row-start:2;grid-row-end:span 3;z-index:10;position:relative}[_nghost-%COMP%]     .shellBreadcrumbGrid{-ms-grid-row:2;-ms-grid-column:2;grid-row:2;grid-column:2}[_nghost-%COMP%]     .shellKittLoaderGrid{-ms-grid-row:3;-ms-grid-column:2;grid-row:3;grid-column:2;margin-top:-3px}[_nghost-%COMP%]     .shellContainerGrid{-ms-grid-row:4;grid-column:2;grid-row:4;overflow-y:auto;position:relative;z-index:1}"] });
/** @nocollapse */
ShellComponent.ctorParameters = () => [
    { type: BreadcrumbService },
    { type: BrowserPendingChangesService }
];
ShellComponent.propDecorators = {
    routerOutlet: [{ type: ViewChild, args: ['routerOutlet', { read: RouterOutlet, static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ShellComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-shell',
                template: "<div class=\"shellGrid\" id=\"modal-full-lateral-container\">\r\n    <div class=\"shellHeaderGrid\">\r\n        <ng-content select='shell-header'></ng-content>\r\n    </div>\r\n    <div class=\"shellSideBarGrid\">\r\n        <ng-content select='shell-side-bar'></ng-content>\r\n    </div>\r\n    <div class=\"shellBreadcrumbGrid\">\r\n        <ngwk-breadcrumb></ngwk-breadcrumb>\r\n    </div>\r\n    <div class=\"shellKittLoaderGrid\">\r\n        <ngwk-kitt-loader></ngwk-kitt-loader>\r\n    </div>\r\n    <div id=\"modal-lateral-container\" class=\"shellContainerGrid\">\r\n        <router-outlet #routerOutlet (activate)=\"onComponentLoaded($event)\"></router-outlet>\r\n    </div>\r\n</div>\r\n",
                styles: [":host ::ng-deep .shellGrid{display:grid;height:100%;width:100%;grid-template-columns:auto 1fr;grid-template-rows:auto auto auto 1fr}:host ::ng-deep .shellHeaderGrid{grid-row:1;-ms-grid-column:1;-ms-grid-column-span:2;grid-column-start:1;grid-column-end:span 2}:host ::ng-deep .shellSideBarGrid{width:60px;-ms-grid-row:2;-ms-grid-column:1;-ms-grid-row-span:3;grid-column:1;grid-row-start:2;grid-row-end:span 3;z-index:10;position:relative}:host ::ng-deep .shellBreadcrumbGrid{-ms-grid-row:2;-ms-grid-column:2;grid-row:2;grid-column:2}:host ::ng-deep .shellKittLoaderGrid{-ms-grid-row:3;-ms-grid-column:2;grid-row:3;grid-column:2;margin-top:-3px}:host ::ng-deep .shellContainerGrid{-ms-grid-row:4;grid-column:2;grid-row:4;overflow-y:auto;position:relative;z-index:1}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.BreadcrumbService }, { type: ɵngcc1.BrowserPendingChangesService }]; }, { routerOutlet: [{
            type: ViewChild,
            args: ['routerOutlet', { read: RouterOutlet, static: true }]
        }] }); })();

/** @ignore */
class KittLoaderService {
    constructor() {
        this._started = false;
        this._startInit = new Subject();
        this._stopInit = new Subject();
    }
    start() {
        if (!this._started) {
            this._started = true;
            this._startInit.next(this._started);
        }
    }
    stop() {
        if (this._started) {
            this._started = false;
            this._stopInit.next(this._started);
        }
    }
    get onStart() {
        return this._startInit.asObservable();
    }
    get onStop() {
        return this._stopInit.asObservable();
    }
}
KittLoaderService.ɵfac = function KittLoaderService_Factory(t) { return new (t || KittLoaderService)(); };
KittLoaderService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: KittLoaderService, factory: KittLoaderService.ɵfac });
/** @nocollapse */
KittLoaderService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(KittLoaderService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * Este componente se utiliza para la declaración de un loader que se activa cuando suceden descargas HTTP en la aplicación
 *
 * @example
 * <ngwk-kitt-loader></ngwk-kitt-loader>
 *
 */
class KittLoaderComponent {
    /** @ignore */
    constructor(_loaderService, cd) {
        this._loaderService = _loaderService;
        this.cd = cd;
        this._showLoader = false;
        this._isAlive = true;
    }
    ngOnInit() {
        this._loaderService.onStart.pipe(debounceTime(10), takeWhile(() => this._isAlive)).subscribe((show) => this.loading(show));
        this._loaderService.onStop.pipe(debounceTime(500), takeWhile(() => this._isAlive)).subscribe((show) => this.loading(show));
    }
    ngOnDestroy() {
        this._isAlive = false;
    }
    /** @ignore */
    loading(show) {
        const hasChanged = this._showLoader !== show;
        this._showLoader = show;
        if (hasChanged) {
            this.cd.markForCheck();
        }
    }
    /** @ignore */
    get showLoader() {
        return this._showLoader;
    }
}
KittLoaderComponent.ɵfac = function KittLoaderComponent_Factory(t) { return new (t || KittLoaderComponent)(ɵngcc0.ɵɵdirectiveInject(KittLoaderService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
KittLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: KittLoaderComponent, selectors: [["ngwk-kitt-loader"]], decls: 5, vars: 1, consts: [[3, "hidden"], [1, "loadingContainer"], [1, "loadingProgress", "left"], [1, "loadingProgress", "right"]], template: function KittLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelement(4, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.showLoader);
    } }, styles: [".loaderContainer[_ngcontent-%COMP%]{width:100%;position:absolute;top:0;z-index:1}.loadingContainer[_ngcontent-%COMP%]{width:50%;height:3px;overflow:hidden;background-color:#0081c6;float:left}.loadingProgress[_ngcontent-%COMP%]{background-color:#cfdfed;margin-top:0;margin-left:0%;-moz-animation-duration:3.2s;-moz-animation-iteration-count:infinite;-moz-animation-timing-function:linear;-webkit-animation-duration:3.2s;-webkit-animation-iteration-count:infinite;-webkit-animation-timing-function:linear;-o-animation-duration:3.2s;-o-animation-iteration-count:infinite;-o-animation-timing-function:linear;-ms-animation-duration:3.2s;-ms-animation-iteration-count:infinite;-ms-animation-timing-function:linear;animation-duration:3.2s;animation-iteration-count:infinite;animation-timing-function:linear;width:50%;height:3px}.loadingProgress.left[_ngcontent-%COMP%]{animation-name:animation_loadingProgressLeft}.loadingProgress.right[_ngcontent-%COMP%]{animation-name:animation_loadingProgressRight}@keyframes animation_loadingProgressLeft{0%{margin-left:100%}to{margin-left:-50%}}@keyframes animation_loadingProgressRight{0%{margin-left:-50%}to{margin-left:100%}}"], changeDetection: 0 });
/** @nocollapse */
KittLoaderComponent.ctorParameters = () => [
    { type: KittLoaderService },
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(KittLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-kitt-loader',
                template: "<div [hidden]=\"!showLoader\">\r\n\t<div class=\"loadingContainer\">\r\n\t\t<div class=\"loadingProgress left\"></div>\r\n\t</div>\r\n\t<div class=\"loadingContainer\">\r\n\t\t<div class=\"loadingProgress right\"></div>\r\n\t</div>\r\n</div>",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".loaderContainer{width:100%;position:absolute;top:0;z-index:1}.loadingContainer{width:50%;height:3px;overflow:hidden;background-color:#0081c6;float:left}.loadingProgress{background-color:#cfdfed;margin-top:0;margin-left:0%;-moz-animation-duration:3.2s;-moz-animation-iteration-count:infinite;-moz-animation-timing-function:linear;-webkit-animation-duration:3.2s;-webkit-animation-iteration-count:infinite;-webkit-animation-timing-function:linear;-o-animation-duration:3.2s;-o-animation-iteration-count:infinite;-o-animation-timing-function:linear;-ms-animation-duration:3.2s;-ms-animation-iteration-count:infinite;-ms-animation-timing-function:linear;animation-duration:3.2s;animation-iteration-count:infinite;animation-timing-function:linear;width:50%;height:3px}.loadingProgress.left{animation-name:animation_loadingProgressLeft}.loadingProgress.right{animation-name:animation_loadingProgressRight}@keyframes animation_loadingProgressLeft{0%{margin-left:100%}to{margin-left:-50%}}@keyframes animation_loadingProgressRight{0%{margin-left:-50%}to{margin-left:100%}}\n"]
            }]
    }], function () { return [{ type: KittLoaderService }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

class KittLoaderModule {
}
KittLoaderModule.ɵfac = function KittLoaderModule_Factory(t) { return new (t || KittLoaderModule)(); };
KittLoaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: KittLoaderModule });
KittLoaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(KittLoaderModule, [{
        type: NgModule,
        args: [{
                exports: [KittLoaderComponent],
                declarations: [KittLoaderComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(KittLoaderModule, { declarations: [KittLoaderComponent], exports: [KittLoaderComponent] }); })();

/**
 * Este componente sirve para declarar el header principal de la aplicación, el cual consiste en diferentes secciones:
 *
 *
 * - Company Info: Se le pasa el un objeto que contenga toda la información de la compañia, en este caso únicamente el nombre
 *
 * - User Info: Se le pasa un objeto que contenga toda la información del usuario, en este caso úniamente el nombre. Contiene
 * algunas funcionalidades extras que aparecen al hacer click, y se determinan a través de un Input userMenuItems
 *
 * @example
 * <ngwk-header [company]='company' [user]='user' [userMenuItems]='userMenuItems'></ngwk-header>
 */
class HeaderComponent {
    /** @ignore */
    constructor(_navigationService, _notificationsService, _localeService, _renderer, _changeDetectorRef) {
        this._navigationService = _navigationService;
        this._notificationsService = _notificationsService;
        this._localeService = _localeService;
        this._renderer = _renderer;
        this._changeDetectorRef = _changeDetectorRef;
        /** Permite definir el título del header de la shell */
        this.headerTitle = 'Wolters Kluwer';
        /** Permite definir el valor del parámetro 'canChangeCompany', que determina si aparece o no el botón de cambio de empresa */
        this.canChangeCompany = true;
        /** Permite definir el valor del parámetro 'changeCompanyTooltip', que determina el tooltip que aparece en el icono de 'search' */
        this.changeCompanyTooltip = null;
        /** Permite definir el valor del parámetro 'changeCompanyTooltipPosition', que determina la posición del tooltip que aparece en el icono de 'search' */
        this.changeCompanyTooltipPosition = 'bottom';
        /** Permite ocultar el botón de notificaciones */
        this.hideNotificationButton = false;
        /** Permite ocultar el selector de empresa */
        this.hideCompanySelector = false;
        /** Permite saber cuando se ha cambiado de compañia a través de un evento */
        this.changeCompany = new EventEmitter();
        /** Permite saber cuando se ha hecho click en la UserCard */
        this.userCardClick = new EventEmitter();
        /** @ignore */
        this.notificationsTooltipText = null;
        /** @ignore */
        this.showNotifications = false;
        this.notificationsBadgeLeftDistance = 0;
        this.anchor = null;
        this._documentClickEventSubscription = null;
    }
    set content(content) {
        if (content) {
            this.anchor = content;
        }
    }
    /** @ignore */
    ngOnInit() {
        this.notificationsTooltipText = this._localeService.getLocaleString('notifications');
        this._notificationsService.openNotification$.subscribe(() => this.onOpenNotification());
    }
    ngAfterViewInit() {
        this.notificationsBadgeLeftDistance = this.anchor ? this.anchor.nativeElement.offsetLeft + 25 : 0;
        this._changeDetectorRef.detectChanges();
    }
    onOpenNotification() {
        this.showNotifications = false;
    }
    onDocumentClick(event) {
        if (!this.contains(event.target)) {
            this.showNotifications = false;
        }
    }
    contains(target) {
        var _a;
        const notificationsPopup = document.getElementById('headerNotificationsPopup');
        return (((_a = this.anchor) === null || _a === void 0 ? void 0 : _a.nativeElement.contains(target)) || (notificationsPopup && notificationsPopup.contains(target)));
    }
    /** @ignore */
    onShowNotificationsChange() {
        this.showNotifications = !this.showNotifications;
        this._documentClickEventSubscription = this._renderer.listen('document', 'click', (event) => this.onDocumentClick(event));
    }
    /** @ignore */
    onHeaderBarItemClick(buttonItem) {
        this._navigationService.go(buttonItem.navigationAction);
    }
    /** @ignore */
    onChangeCompany() {
        this.changeCompany.emit();
    }
    /** @ignore */
    onUserCardClick() {
        this.userCardClick.emit();
    }
    /** @ignore */
    getHeaderBarItemBadgeId(position) {
        return "header-bat-item-" + position;
    }
    /** @ignore */
    getLeftDistanceForBadge(position) {
        return (position * 45) + 25;
    }
    headerHeaderBarItemHasBadge(headerBarItem) {
        if (headerBarItem.showBadge !== undefined) {
            return Type.getValue(headerBarItem.showBadge);
        }
        return false;
    }
    getHeaderBarItemBadgeColor(headerBarItem) {
        return headerBarItem.badgeColor ? headerBarItem.badgeColor : 'red';
    }
    /** @ignore */
    get totalNewNotifications() {
        let totalNewNotifications = this._notificationsService.totalNewNotifications;
        if (totalNewNotifications > 9) {
            return '9+';
        }
        return totalNewNotifications.toString();
    }
    /** @ignore */
    get showTotalNewNotifications() {
        return this._notificationsService.totalNewNotifications > 0;
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NavigationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NotificationsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.LocaleService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
HeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["ngwk-header"]], viewQuery: function HeaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
    } }, inputs: { headerTitle: "headerTitle", canChangeCompany: "canChangeCompany", changeCompanyTooltip: "changeCompanyTooltip", changeCompanyTooltipPosition: "changeCompanyTooltipPosition", hideNotificationButton: "hideNotificationButton", hideCompanySelector: "hideCompanySelector", user: "user", company: "company", userMenuItems: "userMenuItems", headerBarItems: "headerBarItems" }, outputs: { changeCompany: "changeCompany", userCardClick: "userCardClick" }, ngContentSelectors: _c4, decls: 16, vars: 7, consts: [[1, "headerBar", "horizontalLayout"], [1, "colAuto", "headerBarLeftContent", "alignVerticalMiddle"], ["key", "wkeLogoIcon", 1, "colAuto"], [1, "colAuto"], [1, "colAvailable"], ["class", "companySelectorContent alignVerticalMiddle", 4, "ngIf"], [1, "horizontalLayout", "headerActionSection"], ["class", "headerActionIcon", "ngwkTooltipPosition", "bottom", 3, "id", "ngwkTooltip", "click", 4, "ngFor", "ngForOf"], ["id", "btnHeaderBell", "class", "headerActionIcon", "ngwkTooltipPosition", "bottom", 3, "ngwkTooltip", "click", 4, "ngIf"], [3, "user", "menuItems", "cardClick"], ["id", "headerNotificationsPopup", 3, "showNotifications", "anchor", 4, "ngIf"], [1, "companySelectorContent", "alignVerticalMiddle"], [3, "company"], ["class", "colAuto", 4, "ngIf"], ["id", "btnHeaderSearch", 1, "headerActionIcon", 3, "ngwkTooltip", "ngwkTooltipPosition", "click"], ["key", "search", 1, "colAuto"], ["ngwkTooltipPosition", "bottom", 1, "headerActionIcon", 3, "id", "ngwkTooltip", "click"], [1, "colAuto", 3, "key"], [3, "id", "show", "left", "color", 4, "ngIf"], [3, "id", "show", "left", "color"], ["id", "btnHeaderBell", "ngwkTooltipPosition", "bottom", 1, "headerActionIcon", 3, "ngwkTooltip", "click"], ["anchor", ""], ["key", "bell", 1, "colAuto"], ["id", "notifications-badge", "color", "red", 3, "show", "left"], ["id", "headerNotificationsPopup", 3, "showNotifications", "anchor"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "ucc-icon", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "span");
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, HeaderComponent_div_8_Template, 4, 2, "div", 5);
        ɵngcc0.ɵɵelementStart(9, "div", 3);
        ɵngcc0.ɵɵelementStart(10, "div", 6);
        ɵngcc0.ɵɵtemplate(11, HeaderComponent_button_11_Template, 3, 4, "button", 7);
        ɵngcc0.ɵɵtemplate(12, HeaderComponent_button_12_Template, 5, 4, "button", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 3);
        ɵngcc0.ɵɵelementStart(14, "ngwk-user-card", 9);
        ɵngcc0.ɵɵlistener("cardClick", function HeaderComponent_Template_ngwk_user_card_cardClick_14_listener() { return ctx.onUserCardClick(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(15, HeaderComponent_ngwk_notifications_15_Template, 1, 2, "ngwk-notifications", 10);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.headerTitle);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideCompanySelector);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.headerBarItems);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideNotificationButton);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("user", ctx.user)("menuItems", ctx.userMenuItems);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideNotificationButton);
    } }, directives: function () { return [ɵngcc5.IconComponent, ɵngcc6.NgIf, ɵngcc6.NgForOf, UserCardComponent, CompanyCardComponent, ɵngcc4.NgwkTooltipDirective, ɵngcc7.BadgeComponent, ɵngcc3.NotificationsComponent]; }, styles: ["[_nghost-%COMP%]     .headerActionIcon{width:40px;justify-content:center;height:40px;background-color:transparent;border:none;border-radius:10%;margin-right:5px;cursor:pointer;display:flex;align-items:center}[_nghost-%COMP%]     .headerActionIcon i{color:#fff;font-size:24px}[_nghost-%COMP%]     .headerActionIcon:hover{background-color:#fff}[_nghost-%COMP%]     .headerActionIcon:hover i{color:#0081c6}[_nghost-%COMP%]     .headerActionIcon:active{background-color:#fff}[_nghost-%COMP%]     .headerActionIcon:focus{outline:none}[_nghost-%COMP%]     .headerActionSection{margin-right:0}[_nghost-%COMP%]     .headerBar{height:60px;overflow:visible;background-color:#0081c6;color:#fff;-webkit-touch-callout:none;-o-user-select:none;user-select:none;display:flex;align-items:center;justify-content:center}[_nghost-%COMP%]     .headerBar .alignRight{display:flex;justify-content:flex-end}[_nghost-%COMP%]     .headerBar .headerBarLeftContent{display:flex;padding:0 11px}[_nghost-%COMP%]     .headerBar .headerBarLeftContent ucc-icon{margin-right:13px}[_nghost-%COMP%]     .headerBar .headerBarLeftContent ucc-icon i{font-size:36px}[_nghost-%COMP%]     .headerBar .headerBarLeftContent span{font-size:20px}[_nghost-%COMP%]     .headerBar .companySelectorContent{background-color:#016fa8;display:flex;height:100%;width:350px;margin-right:15px;padding-left:5px}[_nghost-%COMP%]     .headerBar .companySelectorContent .headerCompanyIcon{display:none}[_nghost-%COMP%]     .headerBar .companySelectorContent .headerTitle{font-size:14px}"] });
/** @nocollapse */
HeaderComponent.ctorParameters = () => [
    { type: NavigationService },
    { type: NotificationsService },
    { type: LocaleService },
    { type: Renderer2 },
    { type: ChangeDetectorRef }
];
HeaderComponent.propDecorators = {
    user: [{ type: Input }],
    company: [{ type: Input }],
    headerTitle: [{ type: Input }],
    userMenuItems: [{ type: Input }],
    headerBarItems: [{ type: Input }],
    canChangeCompany: [{ type: Input }],
    changeCompanyTooltip: [{ type: Input }],
    changeCompanyTooltipPosition: [{ type: Input }],
    hideNotificationButton: [{ type: Input }],
    hideCompanySelector: [{ type: Input }],
    changeCompany: [{ type: Output }],
    userCardClick: [{ type: Output }],
    content: [{ type: ViewChild, args: ['anchor', { read: ElementRef, static: false },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-header',
                template: "<div class='headerBar horizontalLayout'>\r\n    <div class='colAuto headerBarLeftContent alignVerticalMiddle'>\r\n        <ucc-icon class='colAuto' key='wkeLogoIcon'></ucc-icon>\r\n        <div class='colAuto'>\r\n            <span>{{ headerTitle }}</span>\r\n          </div>\r\n    </div>\r\n    <div class='colAvailable'>\r\n        <ng-content></ng-content>\r\n    </div>\r\n    <div class=\"companySelectorContent alignVerticalMiddle\" *ngIf=\"!hideCompanySelector\">\r\n        <div class='colAvailable'>\r\n            <ngwk-company-card [company]='company'></ngwk-company-card>\r\n        </div>\r\n        <div *ngIf=\"canChangeCompany\" class='colAuto'>\r\n            <button id='btnHeaderSearch' class='headerActionIcon' (click)=\"onChangeCompany()\" [ngwkTooltip]=\"changeCompanyTooltip\" [ngwkTooltipPosition]=\"changeCompanyTooltipPosition\">\r\n                <ucc-icon class='colAuto' key='search'></ucc-icon>\r\n            </button>\r\n        </div>\r\n    </div>\r\n    <div class='colAuto'>\r\n        <div class=' horizontalLayout headerActionSection'>\r\n            <button *ngFor=\"let headerBarItem of headerBarItems; let position = index\" \r\n                    [id]=\"headerBarItem.id\"  \r\n                    class='headerActionIcon' \r\n                    (click)=\"onHeaderBarItemClick(headerBarItem)\" \r\n                    [ngwkTooltip]=\"headerBarItem.tooltipText\" \r\n                    ngwkTooltipPosition=\"bottom\">\r\n                        <ucc-icon class='colAuto' [key]='headerBarItem.icon'></ucc-icon>\r\n                        <ngwk-badge *ngIf=\"headerHeaderBarItemHasBadge(headerBarItem)\"\r\n                            [id]=\"getHeaderBarItemBadgeId(position)\"\r\n                            [show]=\"true\"\r\n                            [left]=\"getLeftDistanceForBadge(position)\"\r\n                            [color]=\"getHeaderBarItemBadgeColor(headerBarItem)\">\r\n                            \r\n                        </ngwk-badge>\r\n            </button>\r\n            <button #anchor \r\n                    *ngIf=\"!hideNotificationButton\"\r\n                    id='btnHeaderBell' \r\n                    class='headerActionIcon' \r\n                    (click)=\"onShowNotificationsChange()\" \r\n                    [ngwkTooltip]=\"notificationsTooltipText\" \r\n                    ngwkTooltipPosition=\"bottom\">\r\n                        <ucc-icon class='colAuto' key='bell'></ucc-icon>\r\n                        <ngwk-badge\r\n                            id=\"notifications-badge\"\r\n                            [show]=\"showTotalNewNotifications\"\r\n                            [left]=\"notificationsBadgeLeftDistance\"\r\n                            color=\"red\">\r\n                            {{totalNewNotifications}}\r\n                        </ngwk-badge>\r\n            </button>\r\n        </div>\r\n    </div>\r\n    <div class='colAuto'>\r\n        <ngwk-user-card [user]='user' [menuItems]='userMenuItems' (cardClick)=\"onUserCardClick()\"></ngwk-user-card>\r\n    </div>\r\n</div>\r\n<ngwk-notifications *ngIf=\"!hideNotificationButton\" id=\"headerNotificationsPopup\" [showNotifications]=\"showNotifications\" [anchor]=\"anchor\">\r\n</ngwk-notifications>\r\n",
                styles: [":host ::ng-deep .headerActionIcon{width:40px;justify-content:center;height:40px;background-color:transparent;border:none;border-radius:10%;margin-right:5px;cursor:pointer;display:flex;align-items:center}:host ::ng-deep .headerActionIcon i{color:#fff;font-size:24px}:host ::ng-deep .headerActionIcon:hover{background-color:#fff}:host ::ng-deep .headerActionIcon:hover i{color:#0081c6}:host ::ng-deep .headerActionIcon:active{background-color:#fff}:host ::ng-deep .headerActionIcon:focus{outline:none}:host ::ng-deep .headerActionSection{margin-right:0}:host ::ng-deep .headerBar{height:60px;overflow:visible;background-color:#0081c6;color:#fff;-webkit-touch-callout:none;-o-user-select:none;user-select:none;display:flex;align-items:center;justify-content:center}:host ::ng-deep .headerBar .alignRight{display:flex;justify-content:flex-end}:host ::ng-deep .headerBar .headerBarLeftContent{display:flex;padding:0 11px}:host ::ng-deep .headerBar .headerBarLeftContent ucc-icon{margin-right:13px}:host ::ng-deep .headerBar .headerBarLeftContent ucc-icon i{font-size:36px}:host ::ng-deep .headerBar .headerBarLeftContent span{font-size:20px}:host ::ng-deep .headerBar .companySelectorContent{background-color:#016fa8;display:flex;height:100%;width:350px;margin-right:15px;padding-left:5px}:host ::ng-deep .headerBar .companySelectorContent .headerCompanyIcon{display:none}:host ::ng-deep .headerBar .companySelectorContent .headerTitle{font-size:14px}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.NavigationService }, { type: ɵngcc3.NotificationsService }, { type: ɵngcc4.LocaleService }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }]; }, { headerTitle: [{
            type: Input
        }], canChangeCompany: [{
            type: Input
        }], changeCompanyTooltip: [{
            type: Input
        }], changeCompanyTooltipPosition: [{
            type: Input
        }], hideNotificationButton: [{
            type: Input
        }], hideCompanySelector: [{
            type: Input
        }], changeCompany: [{
            type: Output
        }], userCardClick: [{
            type: Output
        }], content: [{
            type: ViewChild,
            args: ['anchor', { read: ElementRef, static: false }]
        }], user: [{
            type: Input
        }], company: [{
            type: Input
        }], userMenuItems: [{
            type: Input
        }], headerBarItems: [{
            type: Input
        }] }); })();

/**
 * @ignore
 */
class CompanyCardComponent {
    constructor() {
    }
    set company(value) {
        this._company = value;
    }
    get company() {
        return this._company;
    }
}
CompanyCardComponent.ɵfac = function CompanyCardComponent_Factory(t) { return new (t || CompanyCardComponent)(); };
CompanyCardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CompanyCardComponent, selectors: [["ngwk-company-card"]], inputs: { company: "company" }, decls: 6, vars: 2, consts: [[1, "horizontalLayout", "headerTitle", "alignVerticalMiddle"], [1, "headerCompanyIcon", "alignMiddle"], ["imageShape", "circular", 3, "ngwkImage", 4, "ngIf"], [1, "colAuto", "textCompanyContent"], ["id", "txtTextCompany"], ["imageShape", "circular", 3, "ngwkImage"]], template: function CompanyCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, CompanyCardComponent_div_2_Template, 1, 1, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "span", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.company == null ? null : ctx.company.logoUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.company == null ? null : ctx.company.name);
    } }, directives: [ɵngcc6.NgIf, ɵngcc7.NgwkImageDirective], styles: [".headerCompanyIcon[_ngcontent-%COMP%]{height:40px;width:40px;border-radius:50%;margin-right:15px;border:1px solid #ccc;overflow:hidden}.headerCompanyIcon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:100%;border-radius:25px}.textCompanyContent[_ngcontent-%COMP%]{max-width:300px;overflow:hidden;text-overflow:ellipsis}.textCompanyContent[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{white-space:nowrap}.headerTitle[_ngcontent-%COMP%]{margin-left:10px;font-size:20px}"] });
/** @nocollapse */
CompanyCardComponent.ctorParameters = () => [];
CompanyCardComponent.propDecorators = {
    company: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CompanyCardComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-company-card',
                template: "<div class='horizontalLayout headerTitle alignVerticalMiddle'>\r\n  <div class='headerCompanyIcon alignMiddle'>\r\n    <div *ngIf=\"company?.logoUrl\" [ngwkImage]=\"company?.logoUrl\" imageShape=\"circular\"></div>\r\n  </div>\r\n  <div class='colAuto textCompanyContent'>\r\n    <span id='txtTextCompany'>{{company?.name}}</span>\r\n  </div>\r\n</div>\r\n",
                styles: [".headerCompanyIcon{height:40px;width:40px;border-radius:50%;margin-right:15px;border:1px solid #ccc;overflow:hidden}.headerCompanyIcon img{height:100%;border-radius:25px}.textCompanyContent{max-width:300px;overflow:hidden;text-overflow:ellipsis}.textCompanyContent span{white-space:nowrap}.headerTitle{margin-left:10px;font-size:20px}\n"]
            }]
    }], function () { return []; }, { company: [{
            type: Input
        }] }); })();

class CompanyCardModule {
}
CompanyCardModule.ɵfac = function CompanyCardModule_Factory(t) { return new (t || CompanyCardModule)(); };
CompanyCardModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CompanyCardModule });
CompanyCardModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            IconModule,
            CommonModule,
            ImageModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CompanyCardModule, [{
        type: NgModule,
        args: [{
                imports: [
                    IconModule,
                    CommonModule,
                    ImageModule
                ],
                declarations: [
                    CompanyCardComponent
                ],
                exports: [
                    CompanyCardComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CompanyCardModule, { declarations: function () { return [CompanyCardComponent]; }, imports: function () { return [IconModule,
        CommonModule,
        ImageModule]; }, exports: function () { return [CompanyCardComponent]; } }); })();

/**@ignore */
class UserCardComponent {
    constructor() {
        this.showMenu = false;
        this.anchorAlign = { horizontal: 'right', vertical: 'bottom' };
        this.popupAlign = { horizontal: 'right', vertical: 'top' };
        this.menuItems = null;
        this.cardClick = new EventEmitter();
    }
    keydown(event) {
        if (event.keyCode === 27) {
            this.onMenuClose();
        }
    }
    documentClick(event) {
        if (this.containsClickableZone(event.target)) {
            this.showMenu = !this.showMenu;
            this.cardClick.emit();
        }
        else {
            this.onMenuClose();
        }
    }
    onMenuClose() {
        this.showMenu = false;
    }
    hasMenuItems() {
        return this.menuItems !== null && this.menuItems !== [];
    }
    containsClickableZone(target) {
        return this.container.nativeElement.contains(target);
    }
}
UserCardComponent.ɵfac = function UserCardComponent_Factory(t) { return new (t || UserCardComponent)(); };
UserCardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UserCardComponent, selectors: [["ngwk-user-card"]], viewQuery: function UserCardComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, 7);
        ɵngcc0.ɵɵviewQuery(_c6, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._icon = _t.first);
    } }, hostBindings: function UserCardComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function UserCardComponent_keydown_HostBindingHandler($event) { return ctx.keydown($event); }, false, ɵngcc0.ɵɵresolveDocument)("click", function UserCardComponent_click_HostBindingHandler($event) { return ctx.documentClick($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { menuItems: "menuItems", user: "user" }, outputs: { cardClick: "cardClick" }, decls: 12, vars: 3, consts: [[1, "horizontalLayout", "headerUserSection"], ["container", ""], [1, "colAuto", "headerUserData"], ["id", "headerUsername", 1, "userNameText"], ["id", "txtIDCDA", 1, "idCDAtext"], [1, "colAuto"], [1, "headerUserPhoto", "alignMiddle"], ["icon", ""], ["id", "btnUser", "key", "user"], [3, "anchor", "anchorAlign", "popupAlign", "close", 4, "ngIf"], [3, "anchor", "anchorAlign", "popupAlign", "close"], [1, "verticalLayout", "menuPopupContent"], [3, "id", "click", 4, "ngFor", "ngForOf"], [3, "id", "click"]], template: function UserCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "div", 6, 7);
        ɵngcc0.ɵɵelement(10, "ucc-icon", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, UserCardComponent_ngwk_popup_11_Template, 3, 4, "ngwk-popup", 9);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.user.name);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.user.company == null ? null : ctx.user.company.idCDA);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showMenu && ctx.hasMenuItems());
    } }, directives: [ɵngcc5.IconComponent, ɵngcc6.NgIf, ɵngcc4.PopupComponent, ɵngcc6.NgForOf], styles: ["[_nghost-%COMP%]     .headerUserSection{margin:0 16px;cursor:default;cursor:pointer}[_nghost-%COMP%]     .headerUserData{line-height:1.4;font-size:13px;align-self:center;text-align:right;color:#fff}[_nghost-%COMP%]     .headerUserPhoto{height:35px;width:35px;border-radius:50%;background-color:#f2f2f2;color:#8d8d8d;margin-left:16px}[_nghost-%COMP%]     .userNameText{font-size:16px;font-family:\"FiraSans SemiBold\"}[_nghost-%COMP%]     .idCDAtext{font-size:12px;color:#d6d6d6;text-transform:uppercase}"] });
UserCardComponent.propDecorators = {
    user: [{ type: Input }],
    menuItems: [{ type: Input }],
    cardClick: [{ type: Output }],
    container: [{ type: ViewChild, args: ['container', { static: true },] }],
    _icon: [{ type: ViewChild, args: ['icon', { static: true },] }],
    keydown: [{ type: HostListener, args: ['document:keydown', ['$event'],] }],
    documentClick: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserCardComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-user-card',
                template: "<div #container class='horizontalLayout headerUserSection'>\r\n  <div class='colAuto headerUserData'>\r\n    <div class=\"userNameText\" id='headerUsername'>{{user.name}}</div>\r\n    <div class=\"idCDAtext\" id='txtIDCDA'>{{user.company?.idCDA}}</div>\r\n  </div>\r\n  <div class='colAuto'>\r\n    <div #icon class='headerUserPhoto alignMiddle'>\r\n      <ucc-icon id=\"btnUser\" key='user'></ucc-icon>\r\n    </div>\r\n  </div>\r\n</div>\r\n<ngwk-popup *ngIf=\"showMenu && hasMenuItems()\"\r\n  [anchor]=\"container\"\r\n  [anchorAlign]=\"anchorAlign\"\r\n  [popupAlign]=\"popupAlign\"\r\n  (close)=\"onMenuClose()\">\r\n    <div class=\"verticalLayout menuPopupContent\">\r\n      <button *ngFor=\"let item of menuItems\" id=\"{{item.id}}\" (click)='item.onClick()'>{{item.label}}</button>\r\n    </div>\r\n</ngwk-popup>\r\n",
                styles: [":host ::ng-deep .headerUserSection{margin:0 16px;cursor:default;cursor:pointer}:host ::ng-deep .headerUserData{line-height:1.4;font-size:13px;align-self:center;text-align:right;color:#fff}:host ::ng-deep .headerUserPhoto{height:35px;width:35px;border-radius:50%;background-color:#f2f2f2;color:#8d8d8d;margin-left:16px}:host ::ng-deep .userNameText{font-size:16px;font-family:\"FiraSans SemiBold\"}:host ::ng-deep .idCDAtext{font-size:12px;color:#d6d6d6;text-transform:uppercase}\n"]
            }]
    }], function () { return []; }, { menuItems: [{
            type: Input
        }], cardClick: [{
            type: Output
        }], keydown: [{
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }], documentClick: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], user: [{
            type: Input
        }], container: [{
            type: ViewChild,
            args: ['container', { static: true }]
        }], _icon: [{
            type: ViewChild,
            args: ['icon', { static: true }]
        }] }); })();

class UserCardModule {
}
UserCardModule.ɵfac = function UserCardModule_Factory(t) { return new (t || UserCardModule)(); };
UserCardModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UserCardModule });
UserCardModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            IconModule,
            FormsModule,
            CommonModule,
            RouterModule,
            PopupModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserCardModule, [{
        type: NgModule,
        args: [{
                imports: [
                    IconModule,
                    FormsModule,
                    CommonModule,
                    RouterModule,
                    PopupModule
                ],
                declarations: [UserCardComponent],
                exports: [UserCardComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UserCardModule, { declarations: function () { return [UserCardComponent]; }, imports: function () { return [IconModule,
        FormsModule,
        CommonModule,
        RouterModule,
        PopupModule]; }, exports: function () { return [UserCardComponent]; } }); })();

class HeaderModule {
}
HeaderModule.ɵfac = function HeaderModule_Factory(t) { return new (t || HeaderModule)(); };
HeaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HeaderModule });
HeaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            IconModule,
            CompanyCardModule,
            UserCardModule,
            TooltipModule,
            NotificationsModule,
            BadgeModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    IconModule,
                    CompanyCardModule,
                    UserCardModule,
                    TooltipModule,
                    NotificationsModule,
                    BadgeModule
                ],
                declarations: [
                    HeaderComponent
                ],
                exports: [
                    HeaderComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HeaderModule, { declarations: function () { return [HeaderComponent]; }, imports: function () { return [CommonModule,
        IconModule, CompanyCardModule, UserCardModule, TooltipModule,
        NotificationsModule,
        BadgeModule]; }, exports: function () { return [HeaderComponent]; } }); })();

class ShellModule {
}
ShellModule.ɵfac = function ShellModule_Factory(t) { return new (t || ShellModule)(); };
ShellModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ShellModule });
ShellModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            RouterModule,
            CommonModule,
            BreadCrumbModule,
            KittLoaderModule,
            HeaderModule
        ], HeaderModule, KittLoaderModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ShellModule, [{
        type: NgModule,
        args: [{
                imports: [
                    RouterModule,
                    CommonModule,
                    BreadCrumbModule,
                    KittLoaderModule,
                    HeaderModule
                ],
                declarations: [
                    ShellComponent
                ],
                exports: [
                    HeaderModule,
                    KittLoaderModule,
                    ShellComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ShellModule, { declarations: function () { return [ShellComponent]; }, imports: function () { return [RouterModule,
        CommonModule,
        BreadCrumbModule, KittLoaderModule, HeaderModule]; }, exports: function () { return [HeaderModule, KittLoaderModule, ShellComponent]; } }); })();

/** @ignore */
class KittLoaderHttpInterceptorService {
    constructor(_loaderService) {
        this._loaderService = _loaderService;
    }
    intercept(httpRequest, next) {
        this._loaderService.start();
        return next.handle(httpRequest).pipe(tap((event) => this._loaderService.stop(), (error) => this._loaderService.stop()));
    }
}
KittLoaderHttpInterceptorService.ɵfac = function KittLoaderHttpInterceptorService_Factory(t) { return new (t || KittLoaderHttpInterceptorService)(ɵngcc0.ɵɵinject(KittLoaderService)); };
KittLoaderHttpInterceptorService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: KittLoaderHttpInterceptorService, factory: KittLoaderHttpInterceptorService.ɵfac });
/** @nocollapse */
KittLoaderHttpInterceptorService.ctorParameters = () => [
    { type: KittLoaderService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(KittLoaderHttpInterceptorService, [{
        type: Injectable
    }], function () { return [{ type: KittLoaderService }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { HeaderComponent, HeaderModule, KittLoaderComponent, KittLoaderHttpInterceptorService, KittLoaderModule, KittLoaderService, ShellComponent, ShellModule, CompanyCardModule as ɵa, CompanyCardComponent as ɵb, UserCardModule as ɵc, UserCardComponent as ɵd };

